// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7ad39b1c] .c-input-required {\n  position: static;\n  height: auto;\n  margin-top: 7px;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n[data-v-7ad39b1c] .c-input-required .c-input-required-text {\n    white-space: normal !important;\n    line-height: 1.2;\n}\n", ""]);
// Exports
module.exports = exports;
